export default __webpack_public_path__ + "static/media/IMG_1023-opt.24158d4d.jpg";